class PreferredReaCmaRequest extends MailtoFactory{

  constructor(options){
    super(options);
  }

  homeValue() {
    _.get(this.home, 'metadata.homeValue')
  }

  _to(){
    return this.rea.email;
  }

  _subject(){
    return `${this.user.first_name} ${this.user.last_name} wants a CMA`;
  }

  _body(){

    return `Hi ${this.rea.first_name},

We have a shared client, ${this.user.first_name} ${this.user.last_name}, and they asked me through Homebot if you would give them a new estimated value. Are you able to do a current market analysis for them?

Homebot makes this pretty easy for both of us.  Once you have a new value, give me a call or email and then I'll update their Homebot.  You'll get credit with your photo and contact info every month going forward.

The details:

${this.$filter('clientNamesForwards')(this.home)}
- ${this.helpers.displayAddress(this.home.address)}
- When you sold it: ${this.$filter('moment')(this.home.soldDate, 'MMMM, YYYY')}
${this._estimateBullet()}
${this._updatesBullet()}

${this.user.first_name}'s phone: ${this.$filter('phone')(this.user.mobile)}
Email: ${this.user.email}

Let me know what you think the value is!

${this.agent.first_name} ${this.agent.last_name}
Don't hesitate to call me with questions: ${this.$filter('phone')(this.$filter('mobile')(this.agent.phones))}


P.S. You can learn more about homebot here: http://homebot.ai/cma`;
  }

  _updatesBullet(){
    if(!this.home.answers.homeUpdatedDescription) return '';

    return `- Updates they made to the home: "${this.home.answers.homeUpdatedDescription}"`;
  }

  _estimateBullet(){
    if(!this.home.answers.isEstimateCorrect) return '';

    return `- They believe that ${this.$filter('money')(this.homeValue())} is ${this.$filter('estimateCorrect')(this.home.answers.isEstimateCorrect)}.`;
  }
}


if(typeof module !== 'undefined' && module.exports)
  module.exports = PreferredReaCmaRequest;
else if(typeof window !== 'undefined')
  window.PreferredReaCmaRequest = PreferredReaCmaRequest;
